import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledIconButton = styled.span`
  &:focus {
    outline: 1px solid
      var(${(props) => props.overridefocus ?? "--primaryColor"});
    visibility: visible !important;
  }
`;
export default class IconButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    style: PropTypes.object,
    overridefocus: PropTypes.string,
  };

  _handleKeyDown(event) {
    event.key == "Enter" ? this.props.onClick(event) : "";
  }

  render() {
    let { id, label, icon, style, cssClass, ...rest } = this.props;

    return (
      <StyledIconButton
        {...(id && id != "" && { id: id })}
        className={"pointer " + cssClass}
        role="button"
        aria-label={label}
        title={label}
        style={style}
        onKeyDown={(event) => this._handleKeyDown(event)}
        onClick={this.props.onClick}
        tabIndex="0"
        {...rest}
      >
        <i className={`iconbutton-icon ${icon}`} aria-hidden="true"></i>
        <span className="sr-only">{label}</span>
      </StyledIconButton>
    );
  }
}

IconButton.defaultProps = {
  label: "",
  id: "",
  icon: "",
  style: {},
  onClick: () => {},
  overridefocus: null,
};
